import React from 'react';

export default class AuditEntity {

  static shape = {
    creationDateTime: React.PropTypes.string, // yyyy-MM-dd'T'HH:mm:ss
    updateDateTime: React.PropTypes.string, // yyyy-MM-dd'T'HH:mm:ss
  };

}



// WEBPACK FOOTER //
// ./shared/src/entity/AuditEntity.js